import { LoadingStates } from '@pb/utils'

export default {
  configuredOffers: [],
  offers: [],
  appliedVouchers: [],
  unAppliedVouchers: [],
  maxVouchers: 2,
  deletedVouchers: [],
  errors: [],
  getVouchersStatus: LoadingStates.NotLoaded,
  postVouchersStatus: LoadingStates.NotLoaded,
  deleteVouchersStatus: LoadingStates.NotLoaded,
  getConfiguredOffersStatus: LoadingStates.NotLoaded,
}
